import DeviceInterface, { DeviceKassaProps } from '@/interfaces/models/device';
import { PosCartPayload } from '@/interfaces/models/posSync';
import { ProductProps } from '@/interfaces/models/product';

enum PRINT_MODES {
  AUTO = 1,
  MANUAL = 2
}

export default class DeviceKassa implements DeviceInterface {
  public role: string = 'POS Kassa';
  public description: string = '';
  public deviceType: number;
  public deviceTypeName: string;
  public discounts: number[];
  public fields: any[];
  public id: string;
  public ip: string;
  public isPrintNumberInTheQueue: boolean;
  public isSecondInfoReceipt: boolean;
  public isCustomerScreenEnabled: boolean;
  public isCustomerScreenImagesEnabled: boolean;
  public isTestPrint: boolean;
  public isTestPrintDefault: boolean;
  public lastReportWithZeroing: number;
  public name: string;
  public printMode: number;
  public ssid: number;
  public testCash: number;
  public typeOfNumberInTheQueue: number;
  public authorized: boolean;
  public skoToken: string | null;
  public syncId: string | null;
  public posType: string | null;
  public connectorType: string | null;

  [key: string]: any;

  public constructor(deviceKassaProps: DeviceKassaProps) {
    this.description = deviceKassaProps.description;
    this.deviceType = deviceKassaProps.deviceType;
    this.deviceTypeName = deviceKassaProps.deviceTypeName;
    this.discounts = deviceKassaProps.discounts;
    this.fields = deviceKassaProps.fields;
    this.id = deviceKassaProps.id;
    this.ip = deviceKassaProps.ip;
    this.isPrintNumberInTheQueue = deviceKassaProps.isPrintNumberInTheQueue;
    this.isSecondInfoReceipt = deviceKassaProps.isSecondInfoReceipt;
    this.isCustomerScreenEnabled = deviceKassaProps.isCustomerScreenEnabled;
    this.isCustomerScreenImagesEnabled = deviceKassaProps.isCustomerScreenImagesEnabled;
    this.isTestPrint = deviceKassaProps.isTestPrint;
    this.isTestPrintDefault = deviceKassaProps.isTestPrintDefault;
    this.lastReportWithZeroing = deviceKassaProps.lastReportWithZeroing;
    this.name = deviceKassaProps.name;
    this.printMode = deviceKassaProps.printMode;
    this.ssid = deviceKassaProps.ssid;
    this.testCash = deviceKassaProps.testCash;
    this.typeOfNumberInTheQueue = deviceKassaProps.typeOfNumberInTheQueue;
    this.authorized = deviceKassaProps.authorized;
    this.skoToken = deviceKassaProps.skoToken;
    this.syncId = deviceKassaProps.syncId;
    this.posType = deviceKassaProps.posType;
    this.connectorType = deviceKassaProps.connectorType;
  }

  public get image() {
    switch (this.posType) {
      case 'alfa':
      case 'alfa-proxy':
        return require('../assets/images/new_devices/kassa-3-in-1-large.png');

      case 'titanA':
      case 'titan':
        return require('../assets/images/devices/pos/titan-a-wifi.png');

      case 'smartx':
        return require('../assets/images/new_devices/kassa-3-topwise-t3-large.png');

      case '4ek':
        return require('../assets/images/new_devices/kassa-3-in-1-large.png');

    }
  }

  public get smallImage() {
    switch (this.posType) {
      case 'alfa':
      case 'alfa-proxy':
        return require('../assets/images/new_devices/kassa-3-in-1.png');

      case 'titanA':
      case 'titan':
        return require('../assets/images/devices/pos/titan-a-wifi.png');

      case 'smartx':
        return require('../assets/images/new_devices/kassa-3-topwise-t3.png');

      case '4ek':
        return require('../assets/images/new_devices/kassa-3-in-1.png');

    }
  }

  public get connectorName(): string {
    switch (this.connectorType) {
      case 'webkassa':
        return 'WebKassa';

      case 'titan':
        return 'Titan';

      case 'ecrs':
        return 'ECRS';

      case 'ikassa':
        return 'iKassa';

      case '4ek':
        return '4Эк';

      default:
        return '';
    }
  }

  public get posName(): string {
    return 'Касса 3 в 1';
  }

  get printModes(): any {
    return PRINT_MODES;
  }

  get isManualAdditionalReceiptPrintMode() {
    return PRINT_MODES.MANUAL === this.printMode;
  }

  prepareCustomerScreenCartPayload(payload: PosCartPayload): PosCartPayload {
    if (this.isCustomerScreenImagesEnabled) {
      return payload;
    }

    return {
      ...payload,
      products: payload.products.map((product) => ({ ...product, image: null })),
    };
  }

  mergeWithNewFields(productFields: ProductProps) {
    for (let key in productFields) {
      if (productFields.hasOwnProperty(key) && this.hasOwnProperty(key)) {
        this[key] = productFields[key];
      }
    }
  }
}
